import { gql } from '__generated__';

export default gql(`
  mutation AddParticipant($input: AddParticipantInput!) {
    addParticipant(input: $input) {
      id
    }
  }
`);
